import React, { PureComponent } from 'react';
import ContentfulHelper from '../../helpers/contentfulhelper';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { historyPushState, currencySign, ieCheck } from '../../helpers/utils';
import { continentFilter, travelStyleFilter, countryFilter, tmsProductsFilter, sortedFilterResults,
  sortedPrice, sortedDuration, filterMonth, yearMonthFilter, allTripsFilterJSON, destinationFilterJSON,
  travelStylesJSON, countryFilterJSON } from '../../helpers/filtershelper';
import { capitaliseFirstLetter, lowerCaseFirstLetter, replaceSpaceDash } from '../../helpers/stringUtils';
import {checkArrayItemExist } from '../../helpers/arrayUtils';
import Products from './components/products/products';
import FilterGroup from './components/filters/filtergroup';
import FilterBar from './components/filters/filterbar';
import Spinner from '../shared/spinner';
import { FetchProducts } from '../../actions/product';
import { SetContentful } from '../../actions/contentful';
import { TIMEPASSCOUNTRY, HOHOCODES } from '../../config';
import Scroll from 'react-scroll';
import whatInput from 'what-input';
import ReactModal from 'react-modal';
import filter from 'lodash/filter';
import Progressbar from '../shared/progressbar';
import Header from '../shared/header';
import Footer from '../shared/footer';
import { CriteoHomepage } from '../../actions/analytics';
import ReactGA from 'react-ga';
import unionBy from 'lodash/unionBy';

const queryString = require('query-string');
const Element = Scroll.Element;
const scroller = Scroll.scroller;



class Search extends PureComponent {

  constructor(){
    super();

    this.state = {
      appReady:false,
      currencyReady:false,
      continentData:[],
      travelStyleData:[],
      productsData:[],
      filteredResults:[],
      countryData:[],
      activeFilter:"",
      months:["January","February","March","April","May","June","July","August","September","October","November","December"],
      nextYearMonths:[],
      dropdownActive:"Popularity",
      departureActive:false,
      departureDates:[],
      departureDatesFilter:[],
      showErrorModal:false,
      searchResults:[],
      mobileFilterActive:false
    }

    //bind event listeners
    this.onContinent = this.onContinent.bind(this);
    this.onTravelStyle = this.onTravelStyle.bind(this);
    this.onDuration = this.onDuration.bind(this);
    this.onBudget = this.onBudget.bind(this);
    this.onCountry = this.onCountry.bind(this);
    this.onFilterReset = this.onFilterReset.bind(this);
    this.onMobileFilter = this.onMobileFilter.bind(this);
    this.onDropDownSelect = this.onDropDownSelect.bind(this);
    this.onMonth = this.onMonth.bind(this);
    this.openErrorModal = this.openErrorModal.bind(this);
    this.closeErrorModal = this.closeErrorModal.bind(this);

    //Criteo home page tracking
    CriteoHomepage();
  }

  openErrorModal(){
    ReactGA.pageview('book.busabout.com/modal/search-error-modal');
    this.setState({showErrorModal:true});
  }
  closeErrorModal(){ this.setState({showErrorModal:false});}

  componentDidMount(){

    ///////////////////////////////////////////////
    // App loading order

    // 1. loadContentfulContent()
    // Load contentful content - Continents, Category how (Travel Styles), and Products
    // Calculate contentful filter counts - Continents, Category how (Travel Styles), country, duration, and budget

    // 2. loadCurrencyContent()
    // Loading currency content - appends currency sign and pricing to product cards
    // Append departure months data to tmsProductsFilter;

    // 3. loadQueryParams
    // Parses any exisitng url query strings

    ///////////////////////////////////////////////

    const { currency:{ iso_currency_code }, FetchProducts, product:{ redirect } } = this.props;

    //Change document title
    document.title = "Book your adventure - Search";

    this.loadContentfulContent();


    //FetchProduct if currency already state
    if(iso_currency_code !== undefined){
      FetchProducts(iso_currency_code);
    }


    // Show error modal
    if(redirect){
      this.setState({showErrorModal:true});
    }

    //determine input device
    whatInput.ask();

  }


  loadContentfulContent(){

    Promise.all([
      ContentfulHelper.fetchEntriesType('categoryWhere', ['fields.name', 'fields.order']),
      ContentfulHelper.fetchEntriesType('category', ['fields.name', 'fields.order']),
      ContentfulHelper.fetchEntriesType('product', '')
    ]).then((results) => {

      const continentResults = results[0];
      const categoryResults = results[1];
      const productResults = results[2];


      // Save modifid contentful state in redux store
      this.props.SetContentful({
        continent:continentResults,
        category:categoryResults,
        products:productResults
      })

      //sort filter values
      const popularitySort = sortedFilterResults(productResults);
      const destinationSort = continentFilter(continentResults, productResults);
      const travelStyleSort = travelStyleFilter(categoryResults, productResults);
      const countriesMod = countryFilter(productResults);

      //format continent and travel styles to include: categories, weburl, and count for fuzzy search
      const allTripsJSON = allTripsFilterJSON(travelStyleSort, productResults);
      const destinationJSON = destinationFilterJSON(destinationSort);
      const travelStyleJSON = travelStylesJSON(travelStyleSort);
      const countriesJSON = countryFilterJSON(countriesMod);


      // Save Contentful content and filter valies
      this.setState({
        continentData: destinationSort,
        travelStyleData: travelStyleSort,
        productsData:popularitySort,
        filteredResults:popularitySort,
        countryData:countriesMod,
        searchResults:unionBy(destinationJSON, travelStyleJSON, countriesJSON, allTripsJSON)
      }, () => {
         this.setState({appReady:true});
      });


     //load destination / travelstyle query parameter
      this.loadQueryParams(window.location.search);


    });
  }



  componentDidUpdate(prevProp, prevState){

    const { FetchProducts, currency, products } = this.props;

    // Get all product data from products API
    if(prevProp.currency !== currency){
      if(currency.iso_currency_code !== undefined) FetchProducts(currency.iso_currency_code);
    }

    // Populate card prices
    if(prevProp.products !== products){
      this.loadCurrencyContent(products);
    }


  }


  loadCurrencyContent(currencyContent){

    const { currency:{iso_currency_code, currency_mask }, contentful:{products, category, continent}  } = this.props;

    //populate prices from products API
    //If CAD / USD filter out stop pass
    const productResults = checkArrayItemExist(iso_currency_code, TIMEPASSCOUNTRY) ? filter(products, function(o){ return o.fields.tourId !== HOHOCODES[1].tourID }) : filter(products, function(o){ return o.fields.tourId !== HOHOCODES[2].tourID }) ;
    const tmsProducts = checkArrayItemExist(iso_currency_code, TIMEPASSCOUNTRY) ? filter(currencyContent, function(o){ return o.tour_id !== HOHOCODES[1].tourID }) : filter(currencyContent, function(o){ return o.tour_id !== HOHOCODES[2].tourID });


    //sort filter values
    const popularitySort = sortedFilterResults(tmsProductsFilter(tmsProducts, productResults, currencySign(currency_mask) ));
    const destinationSort = continentFilter(continent, productResults);
    const travelStyleSort = travelStyleFilter(category, productResults);
    const countriesMod = countryFilter(productResults);



    //save State
    this.setState({
      continentData: destinationSort,
      travelStyleData: travelStyleSort,
      productsData:popularitySort,
      filteredResults:popularitySort,
      countryData:countriesMod,
      nextYearMonths:yearMonthFilter(popularitySort, this.state.months), // Check maxiumum number of next year months to show
    }, () => {
     this.setState({currencyReady:true});
    });

    //load destination / travelstyle query parameter
     this.loadQueryParams(window.location.search);


  }



  loadQueryParams(params){

    const parsed = queryString.parse(params);

    if(parsed.destination){
      switch (parsed.destination) {
        case 'usa-canada':
          this.onContinent("USA & Canada", parsed);
          break;
        case 'north-africa':
          this.onContinent("North Africa", parsed);
          break;
        default:
          this.onContinent(capitaliseFirstLetter(parsed.destination), parsed);
      }
    }

    if(parsed.travelstyle){
      switch(parsed.travelstyle){
        case 'hoho':
          this.onTravelStyle('Hop-on Hop-off Passes', parsed);
        break;
        case 'adventures':
          this.onTravelStyle('Adventures', parsed);
        break;
        case 'sailing':
          this.onTravelStyle('Sailing and Island Hopping', parsed);
        break;
        case 'music':
          this.onTravelStyle('Music Festivals', parsed);
        break;
        case 'culture':
          this.onTravelStyle('Cultural Festivals', parsed);
        break;
        case 'winter':
          this.onTravelStyle('Winter and Ski', parsed);
        break;
        case 'haggis':
        case 'Haggis Adventures - Scotland':
              this.onTravelStyle('Haggis Adventures - Scotland', parsed);
        break;
        case 'shamrock':
        case 'Shamrocker Adventures - Ireland':
            this.onTravelStyle('Shamrocker Adventures - Ireland', parsed);
        break;
        default: this.onFilterReset();
      }


    }


    if(parsed.country){
       this.onCountry(capitaliseFirstLetter(parsed.country), parsed);
    }

  }

  shortenTravelStyleName(travelName){
    switch (travelName) {
      case 'Hop-on Hop-off Passes': return 'hoho';
      case 'Adventures': return 'adventures';
      case 'Sailing and Island Hopping': return 'sailing';
      case 'Music Festivals': return 'music';
      case 'Cultural Festivals': return 'culture';
      case 'Winter and Ski': return 'winter';
      case 'Haggis':
      case 'Haggis Adventures - Scotland':
      return 'haggis';
      case 'Shamrocker':
      case 'Shamrocker Adventures - Ireland':
      return 'shamrock';
      default: this.onFilterReset();
    }
  }


  onCountry(countryName, queryString){
    const { productsData, dropdownActive } = this.state;
    const countryNameMod = (countryName === 'Czechia') ? 'Czechia (Czech Republic)' : countryName;
    const filtered = filter(productsData, function(o){
       for(let i = 0; i < o.fields.countries.length; i++){
         if(o.fields.countries[i].fields.name === countryNameMod){
           return o.fields;
         }
       }
    });

    this.resetDeparture();

    historyPushState('country', lowerCaseFirstLetter(countryName), queryString);

    this.setState({filteredResults: filtered, activeFilter:countryName});

    this.onDropDownSelect(dropdownActive, filtered);

    this.resetCurrent('reset');

    if(!ieCheck()){
      document.body.dispatchEvent(new CustomEvent('ON_COUNTRY_CLICK', { detail: countryName }));
    }
  }

  onContinent(continentName, queryString){
    const { productsData, dropdownActive } = this.state;
    const filtered = filter(productsData, ['fields.categoryWhere.fields.name', continentName]);
    const filteredByPopularity = sortedFilterResults(filtered);
    const newContinentname = replaceSpaceDash(lowerCaseFirstLetter(continentName).replace("&", ""));

    this.resetDeparture();

    historyPushState('destination', newContinentname, queryString);

    this.setState({filteredResults: filteredByPopularity, activeFilter:continentName});

    this.onDropDownSelect(dropdownActive, filteredByPopularity);

    this.resetCurrent('reset');

    if(!ieCheck()){
      document.body.dispatchEvent(new CustomEvent('ON_CONTINENT_CLICK', { detail: continentName }));
    }
  }

  onTravelStyle(travelStyleName, queryString){
    const { productsData, dropdownActive } = this.state;
    const filtered = filter(productsData, ['fields.category.fields.name', travelStyleName]);
    const filteredByPopularity = sortedFilterResults(filtered);

    this.resetDeparture();

    historyPushState('travelstyle', this.shortenTravelStyleName(travelStyleName), queryString);

    this.setState({filteredResults: filteredByPopularity, activeFilter:travelStyleName});

    this.onDropDownSelect(dropdownActive, filteredByPopularity);

    this.resetCurrent('reset');

    if(!ieCheck()){
      document.body.dispatchEvent(new CustomEvent('ON_TRAVELSTYLE_CLICK', { detail: travelStyleName }));
    }
  }

  onDuration(daySelected, dayText){
    const { productsData } = this.state;
    const filtered = filter(productsData, (o) => {
      if(o.fields.duration >= daySelected[0] && o.fields.duration <= daySelected[1]){ return o.fields.duration; }
    });

    const filteredByPopularity = sortedFilterResults(filtered);

    this.resetDeparture();

    this.setState({filteredResults: filteredByPopularity, activeFilter:dayText});

    this.resetCurrent('reset');
  }

  onBudget(budgetSelected, budgetText){
    const { productsData } = this.state;
    const filtered = filter(productsData, (o) => {
      if(o.fields.productsTMS.prices_from.adult_display_price >= Math.floor(budgetSelected[0]) &&
      o.fields.productsTMS.prices_from.adult_display_price <= Math.floor(budgetSelected[1])){
        return o.fields.productsTMS.prices_from.adult_display_price;
      }
    });
    const filteredByPopularity = sortedFilterResults(filtered);

    this.resetDeparture();

    this.setState({filteredResults: filteredByPopularity, activeFilter:budgetText});

    this.resetCurrent('reset');
  }

  onFilterReset(resetName){
    this.setState({
      filteredResults: this.state.productsData,
      activeFilter:""
    });
    this.resetCurrent('reset');
    this.resetDeparture();
  }

  resetCurrent(target){
    if(target === 'reset'){
      scroller.scrollTo('search-products', { duration: 300, delay: 100, smooth: true});
      return true;
    }
  }

  resetDeparture(){
    this.setState({
      departureActive:false,
      departureDates:[],
      departureDatesFilter:[]
    })
  }

  onDropDownSelect(activeItem, arr){

    if(this.state.currencyReady){

      const filterArray = (arr === undefined) ? this.state.filteredResults : arr;

      switch (activeItem) {
        case 'Popularity':
            this.setState({filteredResults: sortedFilterResults(filterArray), dropdownActive:activeItem });
        break;

        case 'Lowest price':
            this.setState({filteredResults:sortedPrice(filterArray, 'low'), dropdownActive:activeItem });
        break;

        case 'Highest price':
            this.setState({filteredResults:sortedPrice(filterArray, 'high'), dropdownActive:activeItem });
        break;

        case 'Longest duration':
          this.setState({filteredResults: sortedDuration(filterArray, 'long'), dropdownActive:activeItem  });
        break;

        case 'Shortest duration':
          this.setState({filteredResults: sortedDuration(filterArray, 'short'), dropdownActive:activeItem  });
        break;

        default:
          this.setState({filteredResults: sortedFilterResults(filterArray), dropdownActive:activeItem  });
      }
    }
  }

  onMonth(monthName, year){


    if(this.state.currencyReady){

      if(!ieCheck()){
        document.body.dispatchEvent(new CustomEvent('ON_FILTER_RESET'));
      }


      // toggle departure dates
      // if month exist in array remove item otherwise add to array
      if(this.state.departureDates.indexOf(monthName) === -1){
        this.setState({departureDates:this.state.departureDates.concat(monthName)}, () => {
          this.setState({filteredResults:filterMonth(this.state.productsData, this.state.departureDates, year)});
        })
      }else{
        const index = this.state.departureDates.indexOf(monthName);
        this.state.departureDates.splice(index, 1)
        this.setState({ departureDates:this.state.departureDates}, () => {
          this.setState({filteredResults:filterMonth(this.state.productsData, this.state.departureDates, year)});
        })
      }

      //Filter bar
      let monthNameWithDate = " " + monthName + " " + year;
      if(this.state.departureDatesFilter.indexOf(monthNameWithDate) === -1){
        this.setState({departureDatesFilter:this.state.departureDatesFilter.concat(monthNameWithDate)})
      }else{
        const index = this.state.departureDatesFilter.indexOf(monthNameWithDate);
        this.state.departureDatesFilter.splice(index, 1)
        this.setState({ departureDatesFilter:this.state.departureDatesFilter})
      }

      this.setState({
        activeFilter:"Departure month",
        departureActive:true
      });

      this.resetCurrent('reset');
    }

  }

  onMobileFilter(){
    this.setState({mobileFilterActive: !this.state.mobileFilterActive});
  }


  render() {

    const { appReady, filteredResults, activeFilter, dropdownActive, departureActive,
      departureDatesFilter, months, nextYearMonths, continentData, travelStyleData,
      countryData, currencyReady, showErrorModal, searchResults, mobileFilterActive } = this.state;
    const { currency:{iso_currency_code, currency_mask }, errorMessages } = this.props;


    if(!appReady && !currencyReady){
      return <Spinner text="Loading..." loadClass="search-loading-spinner" />
    }
    else{

      return (
         <div className="search">
           <Header />
           <Progressbar />
          <Element name="search-products">
            <div className="row">
              <div className="column small-12 large-11 large-offset-0-5">
               <div className="trip-search">
                <div className="row">

              <div className="column small-12">

                <div className={`filter-wrapper ${mobileFilterActive ? 'active' : ''}`}>
                  <FilterBar
                    data={filteredResults}
                    onSelect={this.onFilterReset}
                    active={activeFilter}
                    onDropDown={this.onDropDownSelect}
                    activeDropDown={dropdownActive}
                    departureActive={departureActive}
                    departureDatesFilter={departureDatesFilter}
                    searchResults={searchResults}
                    searchResultContinentOnSelect={this.onContinent}
                    searchResultTravelStyleOnSelect={this.onTravelStyle}
                    searchResultCountryOnSelect={this.onCountry}
                    mobileSelect={this.onMobileFilter}
                    mobileFilterActive={mobileFilterActive}
                   />

                  <span style={{display:mobileFilterActive ? 'block' : 'none'}}>
                     <FilterGroup
                       filterName="filterModalGroup-mobile"
                       active={activeFilter}
                       onMonthSelect={this.onMonth} departureDates={departureDatesFilter} months={months} nextYearMonths={nextYearMonths}
                       onContinentSelect={this.onContinent} continentData={continentData}
                       onTravelStyleSelect={this.onTravelStyle} travelStyleData={travelStyleData}
                       onCountrySelect={this.onCountry} countryData={countryData}
                       onDurationSelect={this.onDuration}
                       onBudgetSelect={this.onBudget} currency={currency_mask} currencyReady={currencyReady}
                     />

                     <div className={`filter-button ${mobileFilterActive ? 'bounceInUp animated':''}`}>
                       <button type="button" onClick={this.onMobileFilter}>Apply</button>
                     </div>
                 </span>

                 </div>

            </div>
          </div>

          <div className="row">
            <div className="column small-12 medium-4 large-3">
              <FilterGroup
                filterName="filterModalGroup-desktop"
                active={activeFilter}
                onMonthSelect={this.onMonth} departureDates={departureDatesFilter} months={months} nextYearMonths={nextYearMonths}
                onContinentSelect={this.onContinent} continentData={continentData}
                onTravelStyleSelect={this.onTravelStyle} travelStyleData={travelStyleData}
                onCountrySelect={this.onCountry} countryData={countryData}
                onDurationSelect={this.onDuration}
                onBudgetSelect={this.onBudget} currency={currency_mask} currencyReady={currencyReady} />

            </div>
            <div className="column small-12 medium-8 large-9">
              <Products data={filteredResults} currency={iso_currency_code} />
            </div>
          </div>
          </div>
              </div>
            </div>
          </Element>


          <ReactModal
            className="error-modal"
            overlayClassName="modal-overlay semi-white"
            isOpen={showErrorModal}
            onRequestClose={this.closeErrorModal}
            contentLabel="Error modal">

            <div className="error-modal-container">
              <div className="row">
                <div className="column small-12">
                  <p className="ba-icon ba_icon_extra_info_alt"></p>
                  <p>{errorMessages['PRODUCT_NOTFOUND']}</p>
                </div>
              </div>
              <button className="modal-close orange" onClick={this.closeErrorModal}>
                <span className="fa fa-times fa-lg"></span>
              </button>
            </div>

          </ReactModal>

          <Footer />
       </div>

      )
    }
  }
}

function mapStateToProps(state){
  return {
    currency:state.currency,
    products:state.products,
    contentful:state.contentful,
    product:state.product,
    errorMessages:state.errorMessages
  }
}


function mapDispatchToProps(dispatch){
  return bindActionCreators({
    FetchProducts,
    SetContentful
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Search);



// WEBPACK FOOTER //
// ./src/components/search/search.js